import React from 'react';

import { formatCurrency } from 'utils';

import { formatFullCurrency, formatSignedCompactCurrency } from '../../reporting/format';
import { HeroStatCard } from '../../reporting/HeroStatCard';
import { MonthlyNetFlow, netFlowTotals } from '../transactions';

interface TransactionsHeroProps {
    flows: MonthlyNetFlow[];
    isLoading?: boolean;
}

// The section's headline figures over the date range, from the same monthly buckets as the chart.
export const TransactionsHero = ({ flows, isLoading }: TransactionsHeroProps) => {
    const { inflow, outflow, net } = netFlowTotals(flows);

    const stats = [
        {
            label: 'Net Flows',
            value: formatSignedCompactCurrency(net),
            tooltip: formatFullCurrency(net),
            calculation:
                'Inflows less outflows in the date range. Dividends and interest count as inflows, as on the chart.',
            signedValue: net,
            showArrow: true,
        },
        {
            label: 'Inflows',
            value: formatCurrency(inflow),
            tooltip: formatFullCurrency(inflow),
            calculation: 'Sum of the positive transaction amounts in the date range.',
        },
        {
            label: 'Outflows',
            value: formatCurrency(outflow),
            tooltip: formatFullCurrency(outflow),
            calculation: 'Sum of the negative transaction amounts in the date range.',
            // Outflows are negative, so this colors them like any other negative money figure.
            signedValue: outflow,
        },
    ];

    return <HeroStatCard stats={stats} isLoading={isLoading} />;
};
